import Button from './Button.vue';
import SegmentControl from './SegmentControl.vue';
import Header from './Header.vue';
import Dropdown from './Dropdown.vue';
import Accordion from './Accordion.vue';
import Switch from './Switch.vue';
import Alert from './Alert.vue';
import BasicCell from './BasicCell.vue';
import ListCell from './ListCell.vue';
import SwitchCell from './SwitchCell.vue';
import FavoriteButton from './FavoriteButton.vue';

import ServiceDataCell from './ServiceDataCell.vue';
import ServiceRequest from './ServiceRequest.vue';

import ProjectCell from './ProjectCell.vue';
import ProjectList from './ProjectList.vue';

import BoxCell from './BoxCell.vue';
import BoxList from './BoxList.vue';
import BoxInfo from './BoxInfo.vue';

import OrderCell from './OrderCell.vue';
import OrderList from './OrderList.vue';

import InvoiceCell from './InvoiceCell.vue';
import InvoiceList from './InvoiceList.vue';

import TagInput from './TagInput.vue';
import TimePicker from './TimePicker.vue';

import Loader from './Loader.vue';
import Footer from './Footer.vue';

import AppVersion from './AppVersion.vue';

export default {
  install: Vue => {
    Vue.component(Button.name, Button);
    Vue.component(SegmentControl.name, SegmentControl);
    Vue.component(Header.name, Header);
    Vue.component(Dropdown.name, Dropdown);
    Vue.component(Accordion.name, Accordion);
    Vue.component(Switch.name, Switch);
    Vue.component(Alert.name, Alert);
    Vue.component(BasicCell.name, BasicCell);
    Vue.component(ListCell.name, ListCell);
    Vue.component(ServiceDataCell.name, ServiceDataCell);
    Vue.component(ServiceRequest.name, ServiceRequest);
    Vue.component(SwitchCell.name, SwitchCell);
    Vue.component(FavoriteButton.name, FavoriteButton);
    Vue.component(ProjectCell.name, ProjectCell);
    Vue.component(ProjectList.name, ProjectList);
    Vue.component(BoxCell.name, BoxCell);
    Vue.component(BoxList.name, BoxList);
    Vue.component(BoxInfo.name, BoxInfo);
    Vue.component(OrderList.name, OrderList);
    Vue.component(OrderCell.name, OrderCell);
    Vue.component(OrderList.name, OrderList);
    Vue.component(InvoiceCell.name, InvoiceCell);
    Vue.component(InvoiceList.name, InvoiceList);
    Vue.component(TagInput.name, TagInput);
    Vue.component(TimePicker.name, TimePicker);
    Vue.component(Loader.name, Loader);
    Vue.component(Footer.name, Footer);
    Vue.component(AppVersion.name, AppVersion);
  },
};
